const sexOptions: {
  label: string;
  value: string;
}[] = ["Female", "Male"].map((option) => ({
  value: option,
  label: option,
}));

const pronounOptions: {
  label: string;
  value: string;
}[] = [
  { label: "She/Her", value: "she/her" },
  { label: "He/Him", value: "he/him" },
  { label: "They/Them", value: "they/them" },
  { label: "Xe/Xem", value: "xe/xem" },
  { label: "Ze/Zir", value: "ze/zir" },
  { label: "Something else", value: "something-else" },
];

const raceOptions: {
  label: string;
  value: string;
}[] = [
  {
    label: "Native American or Alaska Native",
    value: "Native American or Alaska Native",
  },
  { label: "Black or African American", value: "Black or African American" },
  { label: "White or Caucasian", value: "White or Caucasian" },
  { label: "Asian", value: "Asian" },
  { label: "Hispanic or Latino", value: "Hispanic or Latino" },
  {
    label: "Native Hawaiian or Other Pacific Islander",
    value: "Native Hawaiian or Other Pacific Islander",
  },
  { label: "Other", value: "Other" },
];

export const interestsQuestions = {
  "Listening to music": "Who's your favorite artist right now?",
  "Making music": "What instruments do you play or what kind of music do you make?",
  "Movies / TV": "What's a show or movie you could rewatch a million times?",
  Gaming: "What games are you playing right now?",
  "Drawing / art": "What kind of art do you make or love looking at?",
  Writing: "What do you like writing about?",
  Reading: "What's a book you've been obsessed with lately?",
  Photography: "What kind of pics do you like to take?",
  Dancing: "What's your favorite style of dance or song to dance to?",
  "Cooking / baking": "What's your favorite thing to cook or bake?",
  Food: "What's your fave food?",
  Fashion: "What's your fave brand or aesthetic?",
  "Playing sports": "What sport do you play or love watching?",
  "Being in nature": "What's your favorite outdoor activity or place in nature?",
  "Pets / animals": "What's your favorite animal or tell us about your pets?",
};

export type InterestsQuestionsKeys = keyof typeof interestsQuestions;

const interestsOptions: {
  label: string;
  value: InterestsQuestionsKeys;
}[] = Object.entries(interestsQuestions).map(([key]) => ({
  label: key,
  value: key as InterestsQuestionsKeys,
}));

const struggledWithOptions: {
  label: string;
  value: string;
}[] = [
  "Family stuff",
  "School pressure",
  "Loneliness",
  "Friend drama",
  "Dating / Breakups",
  "Body image",
  "Identity",
  "Low energy",
  "Feeling stuck / unmotivated",
  "The future",
  "Loss / Grief",
  "Big life changes",
].map((option) => ({ value: option, label: option }));

const mostLikeYouOptions: {
  label: string;
  value: string;
}[] = [
  "Night owl",
  "Early bird",
  "Big talker",
  "More of a listener",
  "Goofy",
  "Creative",
  "Go with the flow",
  "Like to plan everything",
  "Quiet",
  "Weird (in a good way)",
].map((option) => ({ value: option, label: option }));

export {
  raceOptions,
  interestsOptions,
  struggledWithOptions,
  mostLikeYouOptions,
  sexOptions,
  pronounOptions,
};
